

// import React, { useEffect, useState } from 'react';
// import AdminAppBody from '../../../../components/admin/AdminAppBody';
// import { useNavigate } from 'react-router-dom';
// import useApiCallHooks from '../../../../hooks/useApiCallHooks';

// const Experienceinfo = () => {
//   const navigate = useNavigate();
//   const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

//   const [experiences, setExperiences] = useState([
//     { name: '', job_role: '', duration: '', description: '' }
//   ]);

//   // 🔹 Fetch existing experiences
//   useEffect(() => {
//     callAPI('get', 'student/get-student-profile-data');
//   }, []);

//   useEffect(() => {
//     if (statusCode === 200 && responce?.data?.experiences) {
//       if (responce.data.experiences.length > 0) {
//         setExperiences(responce.data.experiences);
//       }
//     }
//   }, [responce, statusCode]);

//   // 🔹 Handle field updates
//   const handleExperienceChange = (index, e) => {
//     const updated = [...experiences];
//     updated[index][e.target.name] = e.target.value;
//     setExperiences(updated);
//   };

//   // 🔹 Add new experience
//   const addExperience = () => {
//     setExperiences([...experiences, { name: '', job_role: '', duration: '', description: '' }]);
//   };

//   // 🔹 Remove experience (local + API call if has id)
//   const removeExperience = (index) => {
//     const exp = experiences[index];

//     if (exp?.id) {
//       if (window.confirm('Are you sure you want to delete this experience?')) {
//         callAPI('post', 'student/remove-student-experience', { id: exp.id });
//       }
//     }

//     const updated = [...experiences];
//     updated.splice(index, 1);
//     setExperiences(updated);
//   };
//   useEffect(() => {
//     if (statusCode === 204) {
//     callAPI('get', 'student/get-student-profile-data');

//     }
//   }, [statusCode, navigate]);

//   // 🔹 Submit updated experiences
//   const updateexperience = (e) => {
//     e.preventDefault();
//     callAPI('post', 'student/add-student-experience', { experiences });
//   };

//   // 🔹 Redirect on success
//   useEffect(() => {
//     if (statusCode === 201 || statusCode === 202) {
//       navigate("/student/profile");
//     }
//   }, [statusCode, navigate]);

//   return (
//     <div className="card p-4 shadow-sm">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h5 className="mb-0">Experience</h5>
//         <button type="button" className="btn btn-primary" onClick={addExperience}>
//           Add Experience
//         </button>
//       </div>

//       <form onSubmit={updateexperience}>
//         {experiences.map((exp, index) => (
//           <div key={index} className="bg-light p-3 mb-3 rounded">
//             <div className="row g-3">
//               <div className="col-md-6">
//                 <label>Company Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={exp.name}
//                   onChange={(e) => handleExperienceChange(index, e)}
//                   className="form-control"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <label>Job Role</label>
//                 <input
//                   type="text"
//                   name="job_role"
//                   value={exp.job_role}
//                   onChange={(e) => handleExperienceChange(index, e)}
//                   className="form-control"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <label>Duration</label>
//                 <input
//                   type="text"
//                   name="duration"
//                   value={exp.duration}
//                   onChange={(e) => handleExperienceChange(index, e)}
//                   className="form-control"
//                 />
//               </div>
//               <div className="col-md-12">
//                 <label>Description</label>
//                 <textarea
//                   name="description"
//                   value={exp.description}
//                   onChange={(e) => handleExperienceChange(index, e)}
//                   className="form-control"
//                   rows="3"
//                 />
//               </div>
//               {experiences.length > 1 && (
//                 <div className="col-12 text-end">
//                   <button
//                     type="button"
//                     className="btn btn-danger btn-sm"
//                     onClick={() => removeExperience(index)}
//                   >
//                     Remove
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
//         <div className="text-end">
//           <button type="submit" className="btn btn-primary">Submit Experiences</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Experienceinfo;
import React, { useEffect, useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { useNavigate } from 'react-router-dom';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { toast } from 'react-toastify'; // Make sure toast is imported
const Experienceinfo = () => {
  const navigate = useNavigate();
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [experiences, setExperiences] = useState([
    { name: '', job_role: '', duration: '', description: '' }
  ]);
  // 🔹 Fetch existing experiences
  useEffect(() => {
    callAPI('get', 'student/get-student-profile-data');
  }, []);
  useEffect(() => {
    if (statusCode === 200 && responce?.data?.experiences) {
      if (responce.data.experiences.length > 0) {
        setExperiences(responce.data.experiences);
      }
    }
  }, [responce, statusCode]);
  // 🔹 Handle field updates
  const handleExperienceChange = (index, e) => {
    const updated = [...experiences];
    updated[index][e.target.name] = e.target.value;
    setExperiences(updated);
  };
  // 🔹 Add new experience
  const addExperience = () => {
    setExperiences([...experiences, { name: '', job_role: '', duration: '', description: '' }]);
  };
  // 🔹 Remove experience (local + API call if has id)
  const removeExperience = (index) => {
    const exp = experiences[index];
    if (exp?.id) {
      if (window.confirm('Are you sure you want to delete this experience?')) {
        callAPI('post', 'student/remove-student-experience', { id: exp.id });
      }
    }
    const updated = [...experiences];
    updated.splice(index, 1);
    setExperiences(updated);
  };
  useEffect(() => {
    if (statusCode === 204) {
      toast.success("Experience deleted successfully!");
      setTimeout(() => {
        callAPI('get', 'student/get-student-profile-data'); // Refresh after delete
      }, 3000);
    }
  }, [statusCode]);
  // 🔹 Submit updated experiences
  const updateexperience = (e) => {
    e.preventDefault();
    callAPI('post', 'student/add-student-experience', { experiences });
  };
  // 🔹 Redirect on success
 useEffect(() => {
  if (statusCode === 201 || statusCode === 202 ) {
      toast.success("✅ Experience updated successfully!", {
        autoClose: 2000,
      });
    // Navigate to profile after short delay
    setTimeout(() => {
      navigate("/student/profile");
    }, 1000);
  }
}, [statusCode, navigate]);
  return (
   
    <div className="card p-4 shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Experience</h5>
        <button type="button" className="btn btn-primary" onClick={addExperience}>
          Add Experience
        </button>
      </div>
      <form onSubmit={updateexperience}>
        {experiences.map((exp, index) => (
          <div key={index} className="bg-light p-3 mb-3 rounded">
            <div className="row g-3">
              <div className="col-md-6">
                <label>Company Name</label>
                <input
                  type="text"
                  name="name"
                  value={exp.name}
                  onChange={(e) => handleExperienceChange(index, e)}
                  className="form-control"
                />
              </div>
              <div className="col-md-6">
                <label>Job Role</label>
                <input
                  type="text"
                  name="job_role"
                  value={exp.job_role}
                  onChange={(e) => handleExperienceChange(index, e)}
                  className="form-control"
                />
              </div>
              <div className="col-md-6">
                <label>Duration</label>
                <input
                  type="text"
                  name="duration"
                  value={exp.duration}
                  onChange={(e) => handleExperienceChange(index, e)}
                  className="form-control"
                />
              </div>
              <div className="col-md-12">
                <label>Description</label>
                <textarea
                  name="description"
                  value={exp.description}
                  onChange={(e) => handleExperienceChange(index, e)}
                  className="form-control"
                  rows="3"
                />
              </div>
              {experiences.length > 1 && (
                <div className="col-12 text-end">
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => removeExperience(index)}
                  >
                    Remove
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
        <div className="text-end">
          <button type="submit" className="btn btn-primary">Submit Experiences</button>
        </div>
      </form>
    </div>
  );
};
export default Experienceinfo;
